<template>
    <div class="wrapper" :hidden="hidden || cartItems.length === 0">
        <div class="container">
            <p v-if="cartItems.length === 1">1 Proizvod - {{totalPrice}} RSD</p>
            <p v-else>{{cartItems.length}} Proizvoda - {{totalPrice}} RSD</p>
            <button class="close-button" @click="hidden = true">x</button>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'CartInfo',
        data() {
            return {
                hidden: false
            }
        },
        computed: {
            ...mapGetters([
                'getCartItems',
                'getTotalPrice'
            ]),

            cartItems: {
                get() {
                    return this.getCartItems
                }
            },

            totalPrice: {
                get() {
                    return this.getTotalPrice
                }
            }
        }
    }
</script>

<style scoped>
    .wrapper {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    p {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .container {
        display: flex;
        justify-content: space-between;
    }

    .close-button {
        border: none;
        padding: 10px;
        background: transparent;
    }
</style>